import { useIntl } from "react-intl";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    BannerAlert,
    BannerAlertProps
} from "../../../../libraries/design/components/banner-alert/src/banner-alert.tsx";

export const GuardBannerSection = () => {
    const intl = useIntl();

    if (!checkFeatureFlagGate(featureFlags.gwp9180BannerGuardInAction)) {
        return null;
    }

    const text = intl.formatMessage({
        id: "GuardWebinarGuardInAction.text",
        defaultMessage:
            "Explore the future of Atlassian cloud security at Guard in Action – exclusive sessions, customer panels, and live demos."
    });

    const linkText = intl.formatMessage({
        id: "GuardWebinarGuardInAction.link",
        defaultMessage: "Save your spot now."
    });

    const bannerMessages: BannerAlertProps = {
        text: text,
        id: "GuardWebinar",
        linkText: linkText,
        linkUrl:
            "https://webinars.atlassian.com/s/guard-in-action/home?utm_source=webinar-banner&utm_medium=live-webinar&utm_campaign=P:guard*O:clm*F:cross-sell*C:webinar*H:fy26q3*I:guard-fy26-q3-february-guard-in-action-virtual-event-webinar-banner-wac*Y:access*E:cloud*&utm_sfdc-campaign_id=701QB00000cg5DeYAI",
        dataEventProps: {
            "data-product-key": "customers",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": linkText,
            "data-label-english": "Save your spot now."
        }
    };

    return <BannerAlert {...bannerMessages} />;
};
